import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=d8fb8046&scoped=true"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"
import style0 from "./ContentView.vue?vue&type=style&index=0&id=d8fb8046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fb8046",
  null
  
)

export default component.exports